import { myAccountHomepageSelectorStyles } from "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector";
import { css } from "styled-components";

Object.assign(myAccountHomepageSelectorStyles, {
    ...myAccountHomepageSelectorStyles,
    checkbox: {
        css: css`
            span {
                border: 1px solid #252525 !important;
            }
            label {
                font-size: 14px;
                font-weight: 700;
            }
        `,
    },
});
